// extracted by mini-css-extract-plugin
export var emailBlockLink = "_it-0";